<template>
    <documents-filter-component
        :ui="ui"
        :routeDetails="routeDetails"
        :routeDocuments="routeDocuments"
    ></documents-filter-component>
</template>

<script>
import DocumentsFilterComponent from '@/components/Admin-Employee/Participant/Filters/DocumentsFilterComponent.vue'

export default {
    name : 'DocumentsFilter',
    components: { DocumentsFilterComponent },
    data: () => ({
        ui: 'admin',
        routeDetails: 'admin-participants-detail',
        routeDocuments: 'admin-participants-documents'
    })
}
</script>